<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <form class="search-box position-relative" @submit.prevent="rechercher">
        <input type="text" v-model="searchTerm" @keyup="rechercher"
          class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une catégorie" />
        <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
          <i class="flaticon-search-interface-symbol"></i>
        </button>
      </form>
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddService')">
        <a class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#" data-bs-toggle="modal" data-bs-target="#AddElementModal">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un service
        </a>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                #
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Designation
              </th>
               <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Direction
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(element, index) in elements" :key="index">
              <td class="shadow-none lh-1 fw-medium text-paragraph">
                {{ index + 1 }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-paragraph">
                {{ element.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-paragraph">
                {{ element.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-paragraph">
                {{ element?.direction?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditService')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        data-bs-toggle="modal" data-bs-target="#AddElementModal" @click="modification(element)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteService')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(element.id, elements, 'organisation', 'organisation')">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddElementModal :item="selectedItem" @close="recharger" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { error, suppression } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import { Organisation } from '@/models/Organisation';
import AddElementModal from './AddElementModal.vue';
import JwtService from '@/services/JwtService';

export default defineComponent({
  name: "ListeCategorieDocument",
  components: {
    PaginationComponent,
    AddElementModal
  },
  setup: () => {
    const elements = ref<Array<Organisation>>([])
    const selectedItem = ref<number>(0);
    const addElementModal = ref<null | HTMLElement>(null);
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAll(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher() {
      getAll(page.value, limit.value, searchTerm.value);
    }

    function getAll(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/services?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log("mes donnees", data);
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    function modification(item) {
      // typeOrganisation.value = item;
      selectedItem.value = Number(item.id);
    }
    onMounted(() => {
      getAll();
    });
    const recharger = () => {
      getAll();
    };

      const privileges = ref<Array<string>>(JwtService.getPrivilege());
  
      const checkPermission = (name) => {
        return privileges.value.includes(name);
      }
  

    return {
      getAll,
      checkPermission,
      suppression,
      modification,
      elements,
      recharger,
      selectedItem,
      page,
      totalPages,
      totalElements,
      limit,
      searchTerm,
      handlePaginate,
      rechercher,
      addElementModal
    };
  }

});
</script>